<div [class]="currentTheme" class="bg-plus-2">
  @if (STATE === states.CREATE) {
    <div>
      <h1 mat-dialog-title>{{ 'GENERAL.CREATE_CARD' | translate }}</h1>
      <form [formGroup]="form" class="form-bettor">
        <div mat-dialog-content>
          <mat-form-field>
            <mat-label>{{ 'GENERAL.BETTOR' | translate }}</mat-label>
            <input matInput [formControl]="form.get('bettor')" autocomplete="off" />
            @if (form.get('bettor').errors) {
              <mat-error>{{ form.get('bettor').errors | formError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'GENERAL.VALUE' | translate }}</mat-label>
            <input matInput [formControl]="form.get('value')" type="tel" autocomplete="off" />
            @if (form.get('value').errors) {
              <mat-error>{{ form.get('value').errors | formError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'GENERAL.PIN' | translate }}</mat-label>
            <input
              matInput
              noAutoFill
              isPassword
              [hidePassword]="hidePin"
              [formControl]="form.get('pin')"
            />
            <button mat-icon-button matSuffix type="button" (click)="hidePin = !hidePin">
              <mat-icon>{{hidePin ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (form.get('pin').errors) {
              <mat-error>{{ form.get('pin').errors | formError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'CARD.CONFIRM_PIN' | translate }}</mat-label>
            <input
              matInput
              noAutoFill
              isPassword
              [hidePassword]="hideConfirmPin"
              [formControl]="form.get('confirm_pin')"
            />
            <button mat-icon-button matSuffix type="button" (click)="hideConfirmPin = !hideConfirmPin">
              <mat-icon>{{hideConfirmPin ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (form.get('confirm_pin').errors) {
              <mat-error>{{ form.get('confirm_pin').errors | formError }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div mat-dialog-actions class="flex" style="gap: 4px;">
          <button mat-flat-button class="mat-button-text" (click)="onNoClick()">
            {{ 'GENERAL.CANCEL' | translate }}
          </button>
          <button mat-flat-button
                  class="mat-button-theme-color"
                  (click)="confirm()">
            {{ 'GENERAL.CREATE' | translate }}
          </button>
        </div>
      </form>
    </div>
  }
  @if (STATE === states.SUCCESS) {
    <div>
      <h1 mat-dialog-title>{{ 'CARD.CREATED_CARD' | translate }}</h1>
      <div mat-dialog-content [class]="currentTheme">
        <div class="content-name">
          <span>{{ 'GENERAL.CODE' | translate }}:</span>
          <span class="name color-primary" style="padding-left: 5px">{{ getCode() }}</span>
        </div>
        <div class="content-name">
          <span>{{ 'GENERAL.BETTOR' | translate }}:</span>
          <span class="name color-primary" style="padding-left: 5px">{{ card.bettor }}</span>
        </div>
        <div class="content-name">
          <span>{{ 'GENERAL.VALUE' | translate }}:</span>
          <span class="name color-primary" style="padding-left: 5px">{{ card.value | currencycase }}</span>
        </div>
        <div class="content-name">
          <span>{{ 'GENERAL.DATE' | translate }}:</span>
          <span class="name color-primary" style="padding-left: 5px">{{ card.created_at | date : 'dd/MM/yyyy - HH:mm' }}</span>
        </div>
      </div>
      <div mat-dialog-actions class="separated-actions">
        <button class="print" mat-button (click)="printCard()">{{ 'GENERAL.PRINT' | translate }}</button>
        <button class="confirm" mat-button (click)="onNoClick()">{{ 'GENERAL.CLOSE' | translate }}</button>
      </div>
    </div>
  }
</div>
